import { ExamEventDetailsProvider } from '@exam-center/exam-event-management';
import { useParams } from '@exam-center/router';
import { Outlet } from 'react-router-dom';

export default function ProctoringEventDetailsLayout() {
  const { examCenterCode, examEventId } = useParams(
    '/:examCenterCode/proctoring/exam-events/:examEventId/registrations/:examEventExamineeId',
  );
  return (
    <ExamEventDetailsProvider examCenterCode={examCenterCode} examEventId={examEventId}>
      <Outlet />
    </ExamEventDetailsProvider>
  );
}
